import {getColorFromTheme} from '../../ui-utils';
import styled from 'styled-components';

export const CommentsWrapper = styled.div`
  border-top: 1px solid ${getColorFromTheme('borderLight')};
  padding: 10px;
`;

export const WrapperHeader = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
`;

export const MentionIndicator = styled.div`
  width: 16px;
  height: 16px;
  margin: 0px 5px;
  border-radius: 100px;
  display: flex;
  color: ${getColorFromTheme('alwaysWhite')};
  font-weight: 500;
  align-items: center;
  justify-content: center;
`;

export const InputWrapper = styled.div`
  background: ${getColorFromTheme('white')};
  border: 1px solid ${getColorFromTheme('borderDark')};
  padding: 15px 20px;
  border-radius: 10px;
  max-width: 700px;
  max-height: none;

  &.team-feed-comment-input {
    box-sizing: border-box;
    width: 100%;
    max-width: none;
    max-height: none;
    overflow: visible;
  }

  .inputField {
    height: 80%;
    border: none;
    font-weight: 400;
    font-size: 14px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    resize: none;
  }
`;

export const MentionDetails = styled.div`
  background: ${getColorFromTheme('backgroundDark')};
  border-radius: 10px;
  margin: 10px 0px;
  .link {
    display: flex;
    color: ${getColorFromTheme('textMedium')};
    z-index: -1;
    padding: 8px 2px;
    align-items: center;
  }
`;

export const Button = styled.button`
  width: 36px;
  height: 32px;
  color: ${getColorFromTheme('alwaysWhite')};
  background: ${getColorFromTheme('purple300')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
`;

export const EmojiSuggestionWrapper = styled.div`
  .emojiSelectPopover {
    border: 1px solid red;
    margin-top: 1.75em;
    // position: absolute;
  }
`;
export const InputWrapperHeader = styled.div`
  position: relative;

  .comment-rich-text-toolbar {
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${getColorFromTheme('borderLight')};
  }

  &.team-feed-comment-input__header {
    .team-feed-comment-input__row {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: center;
      gap: 12px;
    }

    .editor {
      min-width: 0;
      max-width: none;
      overflow-y: auto;
    }

    .team-feed-comment-input__actions {
      flex-shrink: 0;
    }

    .team-feed-emoji-popover {
      z-index: 100;
    }

    .team-feed-emoji-popover-title {
      color: ${getColorFromTheme('textBody')};
    }
  }

  .beam-emoji-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    color: ${getColorFromTheme('textMedium')};
    background: transparent;
    border: 1px solid transparent;
    border-radius: 6px;

    &:hover {
      color: ${getColorFromTheme('purple300')};
      background: ${getColorFromTheme('backgroundDark')};
    }

    &:focus-visible {
      outline: 2px solid ${getColorFromTheme('purple300')};
      outline-offset: 2px;
    }
  }

  .beam-visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .beam-emoji-trigger--open {
    color: ${getColorFromTheme('purple300')};
    background: ${getColorFromTheme('purple100')};
    border-color: ${getColorFromTheme('purple300')};
  }

  .emojiSuggestion {
    right: -30px;
    color: ${getColorFromTheme('textBody')};
    background: ${getColorFromTheme('white')};
    border-color: ${getColorFromTheme('borderDark')};
    box-shadow: ${({theme}) => theme.elevation.level2};
  }

  .emojiSuggestion .beam-emoji-group-title {
    color: ${getColorFromTheme('textMuted')};
  }

  .emojiSuggestion .beam-emoji-entry--focused {
    background: ${getColorFromTheme('backgroundDark')};
  }

  .emojiSuggestion .beam-emoji-tone-list {
    background: ${getColorFromTheme('white')};
    border-color: ${getColorFromTheme('borderDark')};
    box-shadow: ${({theme}) => theme.elevation.level1};
  }

  .emojiSuggestion .beam-emoji-nav-entry {
    color: ${getColorFromTheme('textMuted')};
  }

  .emojiSuggestion .beam-emoji-nav-entry--active {
    color: ${getColorFromTheme('purple300')};
  }

  .emojiSuggestion .beam-emoji-scrollbar {
    background: ${getColorFromTheme('borderLight')};
  }

  .emojiSuggestion .beam-emoji-scrollbar-thumb {
    background: ${getColorFromTheme('textMuted')};
  }

  .editor {
    width: 100%;
    max-width: 400px;

    font-size: 14px;
    margin-top: 4px;
    min-height: 40px;
    max-height: 180px;
    overflow-y: auto;
    font-weight: 400;
    position: relative;
  }

  .editor :global(.public-DraftEditor-content) {
    min-height: 40px;
    word-wrap: break-word;
    overflow-x: hidden;
  }

  .editor .public-DraftStyleDefault-ul,
  .editor .public-DraftStyleDefault-ol {
    margin: 4px 0;
    padding-left: 22px;
  }

  .editor a {
    color: ${getColorFromTheme('purple300')};
    text-decoration: underline;
  }

    .editor .public-DraftEditorPlaceholder-root {
    color: ${getColorFromTheme('textBody')};
    pointer-events: none;
    width: 100%;
    font-size: 14px;
    font-weight 400;
  }

  .editor .public-DraftEditorPlaceholder-inner {
    position: absolute;
    pointer-events: none;
  }

  .testing button {
    margin-right: 8px;
  }

  .editor .emojiSuggestions {
    border: 1px solid red;
    margin-top: 1.75em;
    // position: absolute;
  }
  .testing .emojiSuggestions {
    border: 1px solid red;
    margin-top: 1.75em;
    // position: absolute;
  }
`;

export const MentionContainer = styled.div`
  .mentionSuggestionsEntryContainer {
    cursor: pointer;
    padding: 10px 0px;
    z-index: 5;
  }

  .mentionSuggestionsEntryText {
    color: ${getColorFromTheme('textBody')};
    font-weight: 400;

    font-size: 14px;
    line-height: 170%;
  }
`;

export const PopContainer = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  background: ${getColorFromTheme('white')};
  z-index: 5;
  padding: 5px 10px;
  width: 300px;
  box-shadow: ${({theme}) => theme.elevation.level2};
  border-radius: 10px;

  &.team-feed-mention-popover {
    top: 4px;
    left: 0;
    z-index: 50 !important;
    width: min(300px, calc(100vw - 80px));
    max-height: 240px;
    overflow-y: auto;
  }
`;

export const UserHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`;

export const CommentsBodyStyle = styled.div`
  .taggedStyle .mention {
    margin: 0px 5px;
    font-size: 14px;
    color: ${getColorFromTheme('textMedium')};
    font-weight: 600;
    text-decoration: none;
  }
  .taggedStyle .edited {
    color: ${getColorFromTheme('textMuted')};
  }
`;
